import { IconProps } from './type';

export const ICTuroReservation: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 256 256"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect
                x="28"
                y="36"
                width="200"
                height="184"
                rx="26"
                fill="#111827"
            />
            <rect
                x="28"
                y="36"
                width="200"
                height="52"
                rx="26"
                fill="#22C55E"
            />
            <rect x="28" y="62" width="200" height="26" fill="#22C55E" />

            <circle cx="78" cy="62" r="7" fill="#111827" />
            <circle cx="178" cy="62" r="7" fill="#111827" />

            <rect x="56" y="108" width="138" height="8" rx="4" fill="#374151" />
            <rect x="56" y="132" width="94" height="8" rx="4" fill="#374151" />
            <rect x="56" y="156" width="120" height="8" rx="4" fill="#374151" />
            <rect x="56" y="180" width="76" height="8" rx="4" fill="#374151" />

            <circle cx="196" cy="176" r="24" fill="#22C55E" />
            <path
                d="M196 162V184"
                stroke="#111827"
                strokeWidth="7"
                strokeLinecap="round"
            />
            <path
                d="M186 176L196 186L206 176"
                stroke="#111827"
                strokeWidth="7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
